module.exports = __webpack_public_path__ + "s/img/6@2x.4cde8aae.png";